<template>
  <div id="shAppUploadList">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>业务数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>车位状态报表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       @change="loadFloor"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="楼层::">
            <el-select v-model="pageSearch.fFloorName"
                       @change="loadArea"
                       clearable
                       filterable
                       placeholder="请选择楼层"
                       style="width:200px;">
              <el-option v-for="item in floor_list"
                         :key="item.fFloorName"
                         :label="item.fFloorName"
                         :value="item.fFloorName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域::">
            <el-select v-model="pageSearch.fAreaId"
                       clearable
                       filterable
                       placeholder="请选择区域"
                       style="width:200px;">
              <el-option v-for="item in area_list"
                         :key="item.fAreaId"
                         :label="item.fAreaId+'-'+item.fAreaName"
                         :value="item.fAreaId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="泊位状态::">
            <el-select v-model="pageSearch.fBerthStatus"
                       clearable
                       filterable
                       placeholder="请选择泊位状态"
                       style="width:200px;">
              <el-option v-for="item in fBerthStatusList"
                         :key="item.value"
                           :label="item.label"
                           :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!--<el-form-item label="起始日期::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="date"
                            :clearable="false"
                            :picker-options="startMonthOption"
                            @change="selectStartMonth"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            :clearable="false"
                            type="date"
                            :picker-options="endMonthOption"
                            @change="selectEndMonth"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>-->
          <el-form-item label="车牌::">
          <el-input placeholder="请输入车牌"
                    v-model="pageSearch.fPlateCode"
                    class="search">
          </el-input>
        </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
    <el-col :span="6">
      <el-table :data="pageCountData"
                    :height="tableHeight"
                    highlight-current-row
                    v-loading="loading"
                    ref="dt"
                    border
                    stripe
                    style="width: 98%">
            <!--<el-table-column width="50"
                            type="index"
                            :index="indexMethod"
                            label="序号">
            </el-table-column>-->
            <el-table-column prop="nameTemp"
                            min-width="130px"
                            label="名称">
            </el-table-column>
            <el-table-column prop="total"
                            min-width="80px"
                            align="right"
                            label="总车位数">
            </el-table-column>
            <el-table-column prop="occupyCount"
                            min-width="80px"
                            align="right"
                            label="在场车辆">
            </el-table-column>
            <el-table-column prop="spareCount"
                            min-width="80px"
                            align="right"
                            label="剩余车位">
            </el-table-column>
          </el-table>
      </el-col>
      <el-col :span="18" style="float:right">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  ref="dt"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="75px"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fDataTime"
                           width="135px"
                           label="更新时间">
          </el-table-column>
          <!--<el-table-column prop="fParkingId"
                           label="场库编号">
          </el-table-column>-->
          <el-table-column prop="fFloorName"
                           width="75px"
                           label="楼层名称">
          </el-table-column>
          <el-table-column prop="fAreaName"
                           width="75px"
                           label="区域名称">
          </el-table-column>
          <el-table-column prop="fBerthId"
                           width="75px"
                           label="泊位号">
          </el-table-column>
          <!--<el-table-column prop="fStatus"
                           width="75px"
                           label="运营状态">
          </el-table-column>-->
          <!--<el-table-column prop="fType"
                           width="75px"
                           label="泊位类型">
          </el-table-column>-->
          <el-table-column prop="fBerthStatus"
                           width="75px"
                           label="泊位状态">
          </el-table-column>
          <el-table-column prop="fPlateId"
                           label="车牌号码">
          </el-table-column>
          <!--<el-table-column prop="fPlateColor"
                           label="车牌颜色">
          </el-table-column>-->
          <!--<el-table-column prop="fVehicleType"
                           label="车辆类型">
          </el-table-column>-->
          <el-table-column prop="fUpStatus"
                           label="上传状态">
          </el-table-column>
          <el-table-column prop="fChargeup"
                           label="充电类型">
          </el-table-column>
          <el-table-column prop="fBarFree"
                           width="90px"
                           label="无障碍车位">
          </el-table-column>
          <el-table-column prop="fPrtchild"
                           width="90px"
                           label="子母式车位">
          </el-table-column>
          <el-table-column prop="fMech"
                           width="90px"
                           label="机械式车位">
          </el-table-column>
          <!--<el-table-column prop="fBerthIdShow"
                           width="90px"
                           label="地标泊位号">
          </el-table-column>-->
          <!--<el-table-column prop="fDataType"
                           label="数据类型">
          </el-table-column>-->
          <!--<el-table-column label="识别图片" align="center" width="120">
            <template slot-scope="scope">
            <el-image class="image"
                        :src="'data:image/png;base64,' + scope.row.fImage"
                        :preview-src-list="['data:image/png;base64,'+scope.row.fImage]">
                  <template #error>
                    <div class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                </template>
            </el-image>
            </template>
          </el-table-column>-->
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="90">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         :disabled="scope.row.fBerthStatus==='空闲'"
                         @click="viewChannel(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <!--<el-row>
      <el-tabs type="card"
               v-model="activeName">
        <el-tab-pane label="车位数量统计"
                     name="first">
          <el-table :data="pageCountData"
                    highlight-current-row
                    v-loading="loading"
                    ref="dt"
                    border
                    stripe
                    style="width: 100%"
                    height="150">
            <el-table-column width="50"
                            type="index"
                            :index="indexMethod"
                            label="序号">
            </el-table-column>
            <el-table-column prop="nameTemp"
                            label="名称">
            </el-table-column>
            <el-table-column prop="total"
                            align="right"
                            label="总车位数">
            </el-table-column>
            <el-table-column prop="occupyCount"
                            align="right"
                            label="在场车辆">
            </el-table-column>
            <el-table-column prop="spareCount"
                            align="right"
                            label="剩余车位">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-row>-->
    <div class="myChnlEditOrDetail">
      <el-dialog :title="detailTitle"
                 v-dialogDrag
                 :visible.sync="chnlEditOrDetailVisible"
                 class="channelDialog"
                 top="10vh"
                 left="0vh"
                 width="50%">
        <el-form :model="curRowInfo"
                       ref="parkLockForm"
                       label-width="115px">
          <el-row style="padding-top:10px;">
            <el-col :span="8">
              <el-form-item label="客户名称::" prop="fCustID">
                <el-select v-model="curRowInfo.fCustID"
                        filterable
                        placeholder="请选择客户"
                        :disabled="!curRowInfo.isEdit || !curRowInfo.edit"
                        class="myChnlInput"
                        style="width: 100%"
                        @change="setPark($event,1)">
                  <el-option v-for="item in cust_list"
                            :key="item.fCustID"
                            :label="item.unionName"
                            :value="item.fCustID">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="更新时间::">
                <el-input v-model="curRowInfo.fDataTime"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="场库编号::">
                <el-input v-model="curRowInfo.fParkingId"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="泊位号::">
                <el-input v-model="curRowInfo.fBerthId"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="区域名称::">
                <el-input v-model="curRowInfo.fAreaName"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="楼层名称::">
                <el-input v-model="curRowInfo.fFloorName"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="运营状态::">
                <el-input v-model="curRowInfo.fStatus"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="泊位类型::">
                <el-input v-model="curRowInfo.fType"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="泊位状态::">
                <el-input v-model="curRowInfo.fBerthStatus"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="车牌号码::">
                <el-input v-model="curRowInfo.fPlateId"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <!--<el-col :span="8">
              <el-form-item label="车牌颜色::">
                <el-input v-model="curRowInfo.fPlateColor"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>-->
            <!--<el-col :span="8">
              <el-form-item label="车辆类型::">
                <el-input v-model="curRowInfo.fVehicleType"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>-->
            <el-col :span="8">
              <el-form-item label="上传状态::">
                <el-input v-model="curRowInfo.fUpStatus"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="充电类型::">
                <el-input v-model="curRowInfo.fChargeup"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="无障碍车位::">
                <el-input v-model="curRowInfo.fBarFree"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="字母式车位::">
                <el-input v-model="curRowInfo.fPrtchild"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="机械式车位::">
                <el-input v-model="curRowInfo.fMech"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="地标泊位号::">
                <el-input v-model="curRowInfo.fBerthIdShow"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="数据类型::">
                <el-input v-model="curRowInfo.fDataType"
                          style="width:100%"
                          :disabled="!curRowInfo.isEdit"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!--<el-row style="padding-top:12px;padding-left:10px;padding-right:10px">
            <el-col :span="16">
              <el-image class="image"
                          :src="'data:image/png;base64,' + curRowInfo.fImage"
                          :preview-src-list="['data:image/png;base64,'+curRowInfo.fImage]">
                    <template #error>
                      <div class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                  </template>
              </el-image>
            </el-col>
          </el-row>-->
          <el-row style="height:360px;border-top: 2px solid #ccc;">
            <el-col class="tab_img">
              <div class="block">
                <el-image :z-index="3000" :src="'data:image/png;base64,' + curRowInfo.fImage"
                :preview-src-list="['data:image/png;base64,' + curRowInfo.fImage]">
                          @load="in_load">
                  <div slot="error"
                       class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </el-col>
        </el-row>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button type="primary"
                     @click="submitForm('parkLockForm')"
                     v-if="curRowInfo.isEdit"
                     :loading="save_loading">{{save_msg}}</el-button>
          <el-button @click="chnlEditOrDetailVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
import { cust as apiCust } from '../../api/cust'
import $ from 'jquery'
export default {
  data () {
    return {
      currentDate: '',
      activeName: 'first',
      is_export: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      pageCountData: [],
      cust_list: [],
      floor_list: [],
      area_list: [],
      payType_list: [],
      payType_inner_list: [],
      pageCount: 0,
      startTime: '',
      endTime: '',
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fFloorName: '',
        fAreaId: '',
        fPayTypeID: '',
        fInnerName: '',
        fStartTime: '',
        fEndTime: '',
        fPlateCode: '',
        fBerthStatus: ''
      },
      startMonthOption: {
      },
      endMonthOption: {
      },
      total: {
        total: 0
      },
      fBerthStatusList: [{ value: '1', label: '占用' }, { value: '0', label: '空闲' }],
      detailTitle: '查看',
      chnlEditOrDetailVisible: false,
      curRowInfo: {
        fImage: '',
        fCustID: '',
        fCustNo: '',
        fDataTime: '',
        fParkingId: '',
        fBerthId: '',
        fAreaName: '',
        fFloorName: '',
        fStatus: '',
        fType: '',
        fBerthStatus: '',
        fPlateId: '',
        fPlateColor: '',
        fVehicleType: '',
        fRemark: '',
        fChargeup: '',
        fBarFree: '',
        fPrtchild: '',
        fMech: '',
        fBerthIdShow: '',
        fDataType: ''
      }
    }
  },
  methods: {
    in_load (e) {
      this.in_display = 'block'
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.isExport = 0
      api.shAppUploadList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
      api.shAppUploadCountList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageCountData = data.Data.data
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    viewChannel (row) {
      this.detailTitle = '查看车位状态【' + row.fPlateId + '】'
      this.curRowInfo = row
      api.shAppUploadImg(this.curRowInfo).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.chnlEditOrDetailVisible = true
            this.curRowInfo = row
            this.curRowInfo.fCustID = this.pageSearch.fCustID
            this.curRowInfo.isEdit = false
            this.curRowInfo.fImage = data.Data.data[0].fImage
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    getCurrentMonthLast (dt) {
      var date = dt
      var currentMonth = date.getMonth()
      var nextMonth = ++currentMonth
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
      var oneDay = 1000 * 60 * 60 * 24
      var lastTime = new Date(nextMonthFirstDay - oneDay)
      var month = parseInt(lastTime.getMonth() + 1)
      var day = lastTime.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return new Date(date.getFullYear() + '-' + month + '-' + day + ' 23:59:59')
    },
    selectStartMonth () {
      var endMonth = this.endTime.getMonth()
      var startMonth = this.startTime.getMonth()
      if (endMonth !== startMonth) {
        this.endTime = this.getCurrentMonthLast(this.startTime)
      }
      this.endMonthOption = {
        disabledDate: (time) => {
          if (this.startTime !== '') {
            var endMonth = this.startTime.getMonth()
            var minMonth = time.getMonth()
            return time.getTime() < this.startTime.getTime() || minMonth !== endMonth
          }
        }
      }

      var dateyyyyMM = this.$dateFormat(this.startTime, 'yyyyMM')
      if (this.currentDate !== dateyyyyMM) {
        apiCust.allPayType({ date: dateyyyyMM, type: 'payDay', method: 'history' }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.currentDate = dateyyyyMM
              this.payType_list = data.Data || []
            } else {
              this.$message.error('提示：加载支付方式失败')
            }
          }
        })
      }
    },
    selectEndMonth () {
      // var endMonth = this.endTime.getMonth()
      // var startMonth = this.startTime.getMonth()
      // if (endMonth !== startMonth) {
      //   this.startTime = new Date(this.endTime.getFullYear(), this.endTime.getMonth(), 1, 0, 0, 0)
      // }
      // this.startMonthOption = {
      //   disabledDate: (time) => {
      //     if (this.endTime !== '') {
      //       var endMonth = this.endTime.getMonth()
      //       var minMonth = time.getMonth()
      //       return time.getTime() > this.endTime.getTime() || endMonth > minMonth
      //     }
      //   }
      // }
    },
    exportData () {
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.cust_list || []).filter((item) => {
        return item.fCustID === this.pageSearch.fCustID
      })
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd 23:59:59')
      this.pageSearch.isExport = 1
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      api.shAppUploadList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_车位状态报表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    loadFloor (fCustID) {
      this.pageSearch.fFloorName = ''
      this.floor_list = []
      this.pageSearch.fAreaId = ''
      this.area_list = []
      if (!fCustID) { return }
      // 加载场库
      api.shAppCustFloorList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.floor_list = data.Data
          } else {
            this.$message.error('提示：加载楼层列表失败')
          }
        }
      })
    },
    loadArea (fCustID) {
      this.pageSearch.fAreaId = ''
      this.area_list = []
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      if ((this.pageSearch.fFloorName || '').trim().length <= 0) {
        return
      }
      // 加载场库
      api.shAppCustAreaList({ fCustID: this.pageSearch.fCustID, fFloorName: this.pageSearch.fFloorName }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.area_list = data.Data
          } else {
            this.$message.error('提示：加载区域列表失败')
          }
        }
      })
    },
    changePark () {
      // 加载离场数据列表
      this.page_list()
    },
    init () {
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            if (this.cust_list && this.cust_list.length === 1) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
              this.loadFloor(this.pageSearch.fCustID)
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
      this.selectStartMonth()
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    setImgHeight () {
      var formHeight = $('.form_right').height()
      var fplateHeight = $('.fplate_info .el-image').height()
      var carImgHeight = $('.car_img .img').height()
      if (formHeight && fplateHeight > 0) {
        var height = (formHeight - fplateHeight - carImgHeight) / 2
        $('.fplate_info').css({ 'margin-top': height + 'px', 'margin-bottom': height + 'px' })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 210
      obj.tableHeight = clientHeight
      this.setImgHeight()
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 1120000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
#shAppUploadList .tab_img .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
#shAppUploadList .car_img .image-slot {
  width: 200px;
  height: 80px;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
  display: inline-block;
  line-height: 80px;
  text-align: center;
}
#shAppUploadList .tab_img .block {
  text-align: center;
  position: relative;
}
#shAppUploadList .tab_img .demonstration {
  display: block;
  text-align: center;
  margin-bottom: 5px;
  margin-top: 5px;
}
#shAppUploadList .tab_img .el-image {
  width: 550px;
  height: 300px;
  margin-top:20px;
  display: inline-block;
}
#shAppUploadList .tab_img .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
/* .myChnlEditOrDetail .el-textarea__inner {
  display: block;
  resize: vertical;
  padding: 5px 15px;
  line-height: 1.5;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
  font-size: inherit;
  color: #606266;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 13px;
} */
.myChnlEditOrDetail .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
}
.myChnlEditOrDetail
  .el-checkbox__input.is-disabled.is-checked
  .el-checkbox__inner::after {
  border-color: #000000;
}
.myChnlEditOrDetail .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
.myChnlEditOrDetail .el-dialog__title {
  color: white;
}
.myChnlEditOrDetail .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
.myChnlEditOrDetail .el-dialog__body {
  padding: 5px;
  padding-bottom: 0px;
}
.myChnlEditOrDetail .ledDialog .el-dialog__body {
  padding: 0px;
}
.myChnlEditOrDetail .el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #666666;
  cursor: not-allowed;
  /*font-family: 宋体;*/
  font-size: 13px;
}
.myChnlEditOrDetail .myChnlLableClass {
  text-align: right;
  float: left;
  color: #606266;
  line-height: 30px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  /*font-family: 宋体;*/
  font-size: 13px;
}
.myChnlEditOrDetail .is-disabled .el-input__inner,
.myChnlEditOrDetail .is-disabled .el-textarea__inner {
  color: #606266;
}
.myChnlEditOrDetail .el-row {
  margin-bottom: 5px;
}
.myChnlEditOrDetail .el-radio {
  line-height: 2px;
}
/* dialog弹出框样式 */
#shAppUploadList .el-dialog {
  min-width: 840px;
}
#shAppUploadList .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#shAppUploadList .el-dialog__title {
  color: white;
}
#shAppUploadList .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#shAppUploadList .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
/* 文本框样式 */
#shAppUploadList .el-input__inner {
  height: 32px;
  line-height: 32px;
}
#shAppUploadList .el-input.is-disabled .el-input__inner,
#shAppUploadList .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
#shAppUploadList .el-tabs__item {
  height: 32px;
  line-height: 32px;
}
#shAppUploadList .el-input__icon {
  line-height: 32px;
}

/* end */
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}

.image {
  width: 120px;
  height: 50px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 80%;
  background: #f5f7fa;
  color: #909399;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/report/shAppUploadList.vue